import { observer } from "mobx-react-lite";
import { Colors } from "../../../utils/colors";
import { ClutterGraphTopSectionItem } from "./ClutterGraphTopSectionItem";
import { useMatchStatsStore } from "../../../stores/StoreContext";

export const ClutterGraphTopSection = observer(() => {
  const matchStatsStore = useMatchStatsStore();

  return (
    <div style={styles.shotPatternValueContainer}>
      <ClutterGraphTopSectionItem
        statsValue={matchStatsStore.leftCrossPercentage}
      />
      <ClutterGraphTopSectionItem
        statsValue={matchStatsStore.straightPercentage}
      />
      <ClutterGraphTopSectionItem
        statsValue={matchStatsStore.rightCrossPercentage}
      />
    </div>
  );
});

const styles: { [key: string]: React.CSSProperties } = {
  shotPatternValueContainer: {
    height: 104,
    width: "97%",
    backgroundColor: Colors.background,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    display: "flex",
  },
};
